import { Component, signal } from '@angular/core';
import { OtpService, OtpLogin } from 'shared';
import { ButtonComponent, OtpFormComponent, SignupFormComponent } from 'component-library';
import { AuthenticationConfig } from 'shared';
import { NavigationService } from '../auth/navigation/navigation.service';
import {Router} from "@angular/router";

@Component({
  selector: 'lib-otp',
  standalone: true,
  imports: [SignupFormComponent, OtpFormComponent, ButtonComponent],
  templateUrl: './otp.component.html'
})
export class OtpComponent {
  protected readonly signUp = signal(false);
  protected readonly signupUrl = signal<string | undefined>(undefined);
  protected readonly loginError = signal(false);
  protected readonly readyForOtp = signal(false);

  constructor(
    public config: AuthenticationConfig,
    private readonly otpService: OtpService,
    private navigationService: NavigationService,
    private router: Router
  ) {
    this.signUp.set(!!config.otpConfig?.allowSignup);
  }

  doSignup(newUser: OtpLogin) {
    this.otpService.signup(newUser).subscribe(() => this.signUp.set(false));
  }

  doSendOtpRequest(otpRequest: Partial<OtpLogin>) {
    this.otpService.sendOtpRequest(otpRequest).subscribe({
      next: ({ url }) => {
        this.signupUrl.set(url);
        this.readyForOtp.set(true);
        this.loginError.set(false);
      },
      error: () => this.loginError.set(true),
    });
  }

  doLoginRequest(event: { loginUser: OtpLogin; navigateToRoot: boolean }) {
      this.otpService.loginRequest(event.loginUser).subscribe({
        next: () => {
          if (event.navigateToRoot) {
            this.router.navigate(['/']);
          } else {
            this.navigationService.back();
          }
        },
      error: () => this.loginError.set(true),
    });
  }

  signIn() {
    this.signUp.set(false);
    this.loginError.set(false);
    this.readyForOtp.set(false);
  }

  handleSignUp() {
    this.signUp.set(true);
    this.loginError.set(false);
  }
}
